<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit"></login-form>
          <p class="login-tip">输入用户名和密码登录</p>
        </div>
      </Card>
    </div>
    <div class="footer" style="text-align: center; padding: 20px 0">
      Copyright @ 重庆一米软件科技有限公司 |
      <a href="http://beian.miit.gov.cn/" style="color: #515a6e" rel="noopener" target="_blank">渝ICP备2022001309号</a>
    </div>
  </div>
</template>

<script>
  import LoginForm from '_c/login-form'
  import { mapActions } from 'vuex'

  export default {
    components: {
      LoginForm,
    },
    methods: {
      ...mapActions(['handleLogin']),
      handleSubmit({ email, password }) {
        this.handleLogin({ email, password }).then(res => {
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('userInfo', JSON.stringify(res.data.user))
          this.$Message.success('登录成功')
          this.$router.push({
            name: this.$config.homeName,
          })
        })
      },
    },
  }
</script>

